var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavCalculate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 467,
    width: 29,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    transform: "translate(-370 -467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1572 6.125C20.6738 4.58844 19.0362 3.7347 17.4996 4.21814 16.5907 4.50412 15.8788 5.21608 15.5928 6.125L4.08333 6.125 4.08333 7.875 15.5928 7.875C16.0762 9.41156 17.7138 10.2653 19.2503 9.78186 20.1593 9.49588 20.8712 8.78392 21.1572 7.875L23.9167 7.875 23.9167 6.125ZM18.375 8.16667C17.7307 8.16667 17.2083 7.64432 17.2083 7 17.2083 6.35568 17.7307 5.83333 18.375 5.83333 19.0193 5.83333 19.5417 6.35568 19.5417 7 19.5417 7.64432 19.0193 8.16667 18.375 8.16667Z",
    fill: "current",
    transform: "matrix(1.03571 0 0 1 370 467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2083 18.0833C15.9351 18.085 14.8096 18.9109 14.4261 20.125L4.08333 20.125 4.08333 21.875 14.4261 21.875C14.9096 23.4116 16.5471 24.2653 18.0837 23.7819 18.9926 23.4959 19.7046 22.7839 19.9905 21.875L23.9167 21.875 23.9167 20.125 19.9905 20.125C19.6071 18.9109 18.4815 18.085 17.2083 18.0833ZM17.2083 22.1667C16.564 22.1667 16.0417 21.6443 16.0417 21 16.0417 20.3557 16.564 19.8333 17.2083 19.8333 17.8527 19.8333 18.375 20.3557 18.375 21 18.375 21.6443 17.8527 22.1667 17.2083 22.1667Z",
    fill: "current",
    transform: "matrix(1.03571 0 0 1 370 467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 11.0833C8.64348 11.085 7.51794 11.9109 7.13446 13.125L4.08333 13.125 4.08333 14.875 7.13446 14.875C7.6179 16.4116 9.25546 17.2653 10.792 16.7819 11.701 16.4959 12.4129 15.7839 12.6989 14.875L23.9167 14.875 23.9167 13.125 12.6989 13.125C12.3154 11.9109 11.1898 11.085 9.91667 11.0833ZM9.91667 15.1667C9.27235 15.1667 8.75 14.6443 8.75 14 8.75 13.3557 9.27235 12.8333 9.91667 12.8333 10.561 12.8333 11.0833 13.3557 11.0833 14 11.0833 14.6443 10.561 15.1667 9.91667 15.1667Z",
    fill: "current",
    transform: "matrix(1.03571 0 0 1 370 467)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCalculate);
export default __webpack_public_path__ + "static/media/nav-calculate.6c47d90e232b73d8b27e60868c614b43.svg";
export { ForwardRef as ReactComponent };